import { parseStatic } from '@core/utils/assets.utils'
import { PlayerComparison, PlayerComparisonRequest, PlayerSummary } from '@core/models/player.models'
import { parseTeamStatics } from '@core/utils/team.utils'
import { PlayerPosition } from '@core/enums/player.enums'
import { FIELD_PLAYER_POSITION_KEYS } from '@core/constants/player.constants'
import { StaticOrientation } from '@core/enums/statics.enum'

export const mapPlayer = (player: PlayerSummary): PlayerSummary => {
  const mappedPlayer: PlayerSummary = {
    ...player,
    playerId: player.playerId ?? player.id,
    portraitLogo: parseStatic(player.statics, StaticOrientation.Portrait),
    metricPlayerName: `${player.shirtNumber}. ${player.formattedName}`,
    matchdayNumber: null
  }

  if (player.homeTeam) {
    mappedPlayer.homeTeam = parseTeamStatics(player.homeTeam)
  }

  if (player.awayTeam) {
    mappedPlayer.awayTeam = parseTeamStatics(player.awayTeam)
  }

  return mappedPlayer
}

export const mapComparisonResult = (
  { playerA, playerB, ...metrics }: PlayerComparison,
  payload?: Partial<PlayerComparisonRequest>
): PlayerComparison => {
  return {
    ...metrics,
    playerA: {
      ...mapPlayer(playerA as PlayerSummary),
      ...(payload?.playerA ?? {})
    } as PlayerSummary,
    playerB: playerB
      ? ({ ...mapPlayer(playerB as PlayerSummary), ...(payload?.playerB ?? {}) } as PlayerSummary)
      : undefined
  }
}

export const findPlayerDemarcation = (
  demarcation: PlayerPosition
): { id: PlayerPosition; text: string; isSelectable: boolean } =>
  FIELD_PLAYER_POSITION_KEYS.find((item) => item.id === demarcation)
